import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
import { BaseComponent } from "./BaseComponent";
export const Image = forwardRef((props, ref) => (_jsx(BaseComponent, { ref: ref, as: "img", ...props })));
//# sourceMappingURL=Image.js.map